<template>
  <v-container
    grid-list-md
    fluid
  >
    <v-layout column align-center fill-height>
      <v-flex
        class="text-xs-center"
        style="
          position: relative;
          width: 100%;
          height: auto;
          background-size: cover;
        "
      >
        <img
          class="logo"
          style="width: 20em; height: auto;"
          :src="require('@/assets/logomarca.png')"
          alt="Apetrus logomarca"
        >
        <h1
          style="
            position: absolute;
            top: 83%;
            left: 51%;
            transform: translate(-53%, -15%);
            color: #074d6e;
            font-size: 50pt;
            font-family: Georgia, serif;
            font-weight: 600;
            text-align: center;
          "
          >
            PDV
          </h1>
      </v-flex>
      <v-flex class="text-xs-center pt-3 texto">
        <div style="color: #074d6e" class="font-weight-medium display-1 mt-4" v-if="user">
          Insira o Código da Compra
        </div>
      </v-flex>
      <template v-if="!user">
        <v-flex style="width: 300px" class="pt-5">
          <v-form
            v-if="!user"
            class="form m-auto"
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-alert v-model="loginErro" type="error" outline>
              <h4>Atenção!</h4>
              {{ errorMessage }}
            </v-alert>
            <template v-if="!primeiroAcesso">
              <v-text-field
                v-model="login.email"
                class="pb-3"
                box
                label="E-mail"
                hide-details
              ></v-text-field>
              <v-text-field
                class="pb-1"
                v-model="login.password"
                v-on:keyup.enter="fazerLogin"
                box
                label="Senha"
                type="password"
                hide-details
              ></v-text-field>
              <div class="cadastro mb-3 text-xs-center">
                <div class="mb-1 mt-2">
                  <a @click="primeiroAcesso = true">Primeiro acesso</a>
                </div>
                <span>
                  Esqueceu sua senha?
                  <a @click="dialogRedefinir = true">Alterar</a>
                </span>
              </div>

              <div>
                <v-layout row align-space-around>
                  <v-spacer></v-spacer>
                  <v-btn
                    block
                    round
                    dark
                    large
                    :loading="loading"
                    :disabled="loading"
                    color="secondary"
                    class="white--text btnLogin"
                    @click="fazerLogin"
                    >Entrar</v-btn
                  >

                  <v-spacer></v-spacer>
                </v-layout>
              </div>
            </template>
            <template v-else>
              <h2 class="mb-4" style="color: #074d6e; text-align: center">
                Realizar primeiro acesso
              </h2>
              <template v-if="!inserirSenha">
                <v-text-field
                  v-model="email"
                  class="pb-3"
                  hide-details
                  box
                  label="E-mail"
                ></v-text-field>
                <v-text-field
                  v-model="matricula"
                  class="pb-3"
                  hide-details
                  box
                  label="Matrícula"
                ></v-text-field>
              </template>
              <template v-else>
                <v-text-field
                  :disabled="inserirSenha"
                  v-model="email"
                  class="pb-3"
                  hide-details
                  box
                  label="E-mail"
                ></v-text-field>

                <v-text-field
                  hide-details
                  class="pb-1"
                  v-model="senha"
                  box
                  label="Senha"
                  type="password"
                  :rules="[
                    (v) => {
                      if (v) {
                        return (v.length && v.length > 5) || '';
                      } else {
                        return false;
                      }
                    },
                  ]"
                ></v-text-field>

                <v-text-field
                  hide-details
                  class="pb-1 mt-3"
                  v-model="Confirmarsenha"
                  box
                  label="Confirma Senha"
                  type="password"
                  :rules="[
                    (v) => {
                      if (senha !== v) {
                        return 'Senhas Diferentes';
                      }
                      return false;
                    },
                  ]"
                ></v-text-field>
              </template>
              <div>
                <v-layout row align-space-around class="mt-2">
                  <v-btn
                    block
                    round
                    :disabled="loading"
                    @click="primeiroAcesso = false"
                    >Voltar</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    block
                    round
                    :loading="loading"
                    color="secondary"
                    class="white--text btnLogin"
                    @click="opcoes"
                    :disabled="
                      inserirSenha && (senha !== Confirmarsenha || !senha)
                    "
                    >Confirmar</v-btn
                  >
                </v-layout>
              </div>
            </template>
          </v-form>
        </v-flex>
      </template>
      <template v-else>
        <v-flex class="button-over pa-3">
          <v-layout>
            <v-btn
              block
              round
              v-if="!isUserVerified"
              color="error"
              dark
              @click="resendEmail"
              >
                Verifique seu email para iniciar!
              </v-btn>
            <template v-else>
              <v-text-field
                v-model="codigo"
                :loading="loading"
                box
                hide-details
                single-line
                color="primary"
                clearable
                class="centered-input display-1 font-weight-black"
                maxlength="4"
                mask="NNNN"
              ></v-text-field>
            </template>
          </v-layout>
        </v-flex>
      </template>
      <div>
        <template v-if="user && frentista && frentista.posto">
          <v-flex class="text-xs-center pt-3 texto">
            <div style="color: #074d6e" class="font-weight-medium display-1">
              Insira a placa do veículo
            </div>
          </v-flex>
          <v-flex class="button-over pa-3">
            <v-layout>
              <template>
                <!-- here put the text field to insert the car plate-->
                <div class="text-uppercase">
                  <v-text-field
                    v-model="placa"
                    @input="
                      (v) => {
                        this.placa = v.toUpperCase();
                      }
                    "
                    :loading="loading"
                    box
                    hide-details
                    single-line
                    color="primary"
                    clearable
                    class="centered-input display-1 font-weight-black"
                  ></v-text-field>
                </div>
              </template>
            </v-layout>
          </v-flex>
          <v-flex style="min-width: 400px" v-if="clienteplaca">
            <v-toolbar tabs>
              <v-toolbar-title class="ml-0 pl-3">
                <span
                  >{{ clienteplaca.identificacao }}
                  {{ clienteplaca.modelo_marca }}</span
                >
              </v-toolbar-title>
              <template v-slot:extension>
                <v-tabs
                  v-model="tabs"
                  grow
                  color="transparent"
                  slider-color="primary"
                >
                  <v-tab>Compras</v-tab>
                  <v-tab>Compras empresa</v-tab>
                  <v-tab>Créditos Empresa</v-tab>
                </v-tabs>
              </template>
            </v-toolbar>
            <div class="scroll-y" style="max-height: calc(500px)">
              <v-tabs-items v-model="tabs">
                <v-tab-item lazy>
                  <v-list two-line dense>
                    <template v-for="compra in compras">
                      <v-list-tile
                        :key="compra.codigo"
                        ripple
                        @click="() => selectVoucherplaca(null, compra)"
                      >
                        <v-list-tile-action>
                          <v-tooltip
                            v-if="compra.combustivel"
                            :color="pegarCor(compra)"
                            top
                          >
                            <template v-slot:activator="{ on }">
                              <span v-on="on">
                                <svg-filler
                                  :path="
                                    compra.combustivel.icone
                                      ? require(`@/assets/combs/${compra.combustivel.icone}.svg`)
                                      : require(`@/assets/combs/gas.svg`)
                                  "
                                  width="40px"
                                  height="40px"
                                  :fill="pegarCor(compra)"
                                />
                              </span>
                            </template>
                            <span>{{ compra.combustivel.nome }}</span>
                          </v-tooltip>
                          <v-tooltip
                            v-else-if="compra.pedido && compra.pedido.itens && compra.pedido.itens.length > 0"
                            :color="pegarCor(compra)"
                            top
                          >
                            <template v-slot:activator="{ on }">
                              <svg-filler
                                  v-on="on"
                                  v-if="compra.pedido.itens[0].item.combustivel"
                                  :path="
                                    compra.pedido.itens[0].item.combustivel.icone
                                      ? require(`@/assets/combs/${compra.pedido.itens[0].item.combustivel.icone}.svg`)
                                      : require(`@/assets/combs/gas.svg`)
                                  "
                                  width="40px"
                                  height="40px"
                                  :fill="pegarCor(compra)"
                              />
                              <v-icon
                                v-else
                                v-on="on"
                                :color="pegarCor(compra)"
                              >
                                {{ pegarIcone(compra) }}
                              </v-icon>
                            </template>
                            <span>{{ pegarTexto(compra) }}</span>
                          </v-tooltip>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{
                            compra.data_compra.split("-").reverse().join("/")
                          }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-content>
                          <v-list-tile-title class="title font-weight-medium"
                            >{{ compra.valor_total  | currency({ fractionCount: 2 }) }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title>Valor pago</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn icon ripple>
                            <v-icon
                              :color="compra.disponivel ? 'success' : 'error'"
                              >{{
                                compra.disponivel ? "check" : "info"
                              }}
                            </v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-tab-item>
                <!-- get car company -->
                <v-tab-item lazy>
                  <v-list two-line dense>
                    <template v-for="voucherFuncionario in vouchersFuncionario">
                      <v-list-tile
                        :key="retornoNumeroVoucher(voucherFuncionario)"
                        ripple
                        @click="
                          () => selectVoucherplaca(voucherFuncionario.voucher, voucherFuncionario.compra)
                        "
                      >
                      <v-list-tile-avatar>
                        <v-tooltip
                            :color="retornoCombustivelVoucher(voucherFuncionario) && retornoCombustivelVoucher(voucherFuncionario).color"
                            top
                            >
                              <template v-slot:activator="{ on }">
                                <span v-on="on">
                                  <svg-filler
                                    v-if=" retornoCombustivelVoucher(voucherFuncionario)"
                                    :path="
                                      retornoCombustivelVoucher(voucherFuncionario).icone
                                        ? require(`@/assets/combs/${retornoCombustivelVoucher(voucherFuncionario).icone}.svg`)
                                        : require(`@/assets/combs/gas.svg`)
                                    "
                                    width="40px"
                                    height="40px"
                                    :fill="retornoCombustivelVoucher(voucherFuncionario).color"
                                  />
                                </span>
                              </template>
                              <span v-if="retornoCombustivelVoucher(voucherFuncionario)">{{ retornoCombustivelVoucher(voucherFuncionario).nome }}</span>
                          </v-tooltip>
                      </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{
                            retornoDataCriacao(voucherFuncionario)
                              .split("-")
                              .reverse()
                              .join("/")
                          }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-content>
                          <v-list-tile-title class="title font-weight-medium">
                            <template>
                              {{
                                retornoValorVoucher(voucherFuncionario)
                                  | currency({ fractionCount: 2 })
                              }}
                            </template>
                          </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn icon ripple>
                            <v-icon
                              :color="
                                retornoDisponibilidadeVoucher(voucherFuncionario)
                                  ? 'success'
                                  : 'error'
                              "
                              >{{
                                retornoDisponibilidadeVoucher(voucherFuncionario)
                                  ? "check"
                                  : "info"
                              }}</v-icon
                            >
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-tab-item>
                <v-tab-item lazy>
                  <v-list two-line dense>
                    <template v-for="(credito, index) in creditos">
                      <v-list-tile
                        :key="`${index}c`"
                        ripple
                        @click="
                          creditoSelecionado = credito,
                          dialogCreditoEmpresa = true
                        "
                      >
                      <v-list-tile-avatar>
                        <v-tooltip
                          top
                        >
                          <template v-slot:activator="{ on }">
                            <v-icon color="success" v-on="on">payments</v-icon>
                          </template>
                          <span>Crédito disponível para uso</span>
                        </v-tooltip>
                      </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{ credito.veiculo }}
                          </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-content>
                          <v-list-tile-title class="title font-weight-medium">
                            <template>
                              {{
                                credito.valor_disponivel | currency({ fractionCount: 2 })
                              }}
                            </template>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </v-flex>
        </template>
        <!-- Here when selecting the Voucher he opened a page
        to finalize the consumption of the voucher-->
        <!--error or success message is finished-->

        <v-dialog
          width="400px"
          persistent
          v-if="success"
          :value="hasSuccessPlaca"
        >
          <v-card>
            <v-card-title class="ml-2" primary-title>
              <div>
                <div class="success--text headline">{{ success.title }}</div>
              </div>
            </v-card-title>
            <v-card-text
              class="primary--text headline font-weight-medium text-xs-center"
            >
              <span>{{ success.message }}</span>
            </v-card-text>
            <v-card-actions>
              <v-btn block flat color="secondary" @click="fecharDialogSuccess"
                >OK</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- here the operation of the consumption page
        for reservations and vouchers is finalized-->
        <v-dialog width="400px" persistent v-if="error" :value="hasError">
          <v-card>
            <v-card-text
              class="error--text headline font-weight-medium text-xs-center"
            >
              <span>{{ error.message }}</span>
            </v-card-text>
            <v-card-actions>
              <v-btn block flat color="secondary" @click="fecharDialogError"
                >OK</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar
          v-model="snackbar"
          color="info"
          :multi-line="true"
          :timeout="4000"
          :vertical="true"
        >
          {{ snackbar_text }}
          <v-btn flat @click="snackbar = false">Fechar</v-btn>
        </v-snackbar>
      </div>

      <!-- vehicle license plate reading End -->
    </v-layout>
    <v-dialog width="400px" persistent v-if="success" :value="hasSuccess">
      <v-card>
        <v-card-title class="ml-2" primary-title>
          <div>
            <div class="success--text headline">{{ success.title }}</div>
          </div>
        </v-card-title>
        <v-card-text
          class="primary--text headline font-weight-medium text-xs-center"
        >
          <span>{{ success.message }}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn block flat color="secondary" @click="fecharDialogSuccess"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="400px" persistent v-if="error" :value="hasError">
      <v-card>
        <v-card-text
          class="error--text headline font-weight-medium text-xs-center"
        >
          <span>{{ error.message }}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn block flat color="secondary" @click="fecharDialogError"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="cadPin" v-model="cadPin" persistent max-width="360">
      <cad-pin @fechar="cadPin = false" :frentistaSelecionado="frentista" />
    </v-dialog>
    <v-dialog
      v-if="dialogSolicitacao"
      v-model="dialogSolicitacao"
      persistent
      max-width="400"
    >
      <notificacao-solicitacao @fechar="dialogSolicitacao = false" />
    </v-dialog>
    <v-dialog v-model="dialogRedefinir" width="400">
      <reset-password @fechar="dialogRedefinir=false"/>
    </v-dialog>
    <v-dialog v-model="dialogDetathes" v-if="dialogDetathes" width="50em">
      <dialog-detalhes-compra
        @fechar="dialogDetathes=false, compra=undefined, voucher=undefined"
        :compra="compra"
        :voucher="voucher"
        :tipo="tipo"
      />
    </v-dialog>
    <v-dialog
      v-model="dialogCreditoEmpresa"
      v-if="dialogCreditoEmpresa"
      width="50em"
    >
      <credito-empresa
        :credito="creditoSelecionado"
        @fechar="dialogCreditoEmpresa = false, creditoSelecionado = undefined"
      />
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      color="info"
      :multi-line="true"
      :timeout="4000"
      :vertical="true"
    >
      {{ snackbar_text }}
      <v-btn flat @click="snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>

import CadPin from '@/components/dialogs/CadPin'
import NotificacaoSolicitacao from '@/components/dialogs/NotificacaoSolicitacaoRetirada'
import ResetPassword from '@/components/dialogs/SendResetPassword'
import DialogDetalhesCompra from '@/components/dialogs/DetalhesCompra'
import CreditoEmpresa from '@/components/dialogs/CreditoEmpresa'

export default {
  components: {
    CadPin,
    NotificacaoSolicitacao,
    ResetPassword,
    DialogDetalhesCompra,
    CreditoEmpresa
  },
  data () {
    return {
      dialogSolicitacao: false,
      dialogCreditoEmpresa: false,
      creditoSelecionado: undefined,
      cadPin: false,
      voucher: undefined,
      clienteSelecionado: null,
      placaCliente: '',
      codigo: '',
      compra: undefined,
      dialogDetathes: false,
      tipo: 'codigo',
      snackbar: false,
      snackbar_text: null,
      tabs: null,
      placa: '',
      loginErro: false,
      errorMessage: '',
      valid: true,
      login: {
        email: '',
        password: '',
        tipo: ''
      },
      primeiroAcesso: false,
      email: '',
      matricula: '',
      inserirSenha: false,
      senha: '',
      Confirmarsenha: '',
      dialogRedefinir: false
    }
  },
  watch: {
    hasPin (val) {
      if (val) {
        if (this.primeiroAcesso) {
          let interval = setInterval(() => {
            this.cadPin = true
            clearInterval(interval)
          }, 5000 * 4)
        } else {
          this.cadPin = true
        }
      }
    },
    hasSuccess (val) {
      if (val) {
        this.codigo = ''
      }
    },
    hasSuccessPlaca (val) {
      if (val) {
        this.placa = ''
      }
    },
    completed (val) {
      if (val) {
        this.pegarInformacoes()
      } else {
        this.$store.dispatch('clean')
      }
    },
    completedPlaca (val) {
      if (val) {
        this.$store.dispatch('lookupVouchersPlaca', {
          veiculo: this.placa
        })
      } else {
        this.$store.dispatch('clean')
      }
    },
    notificacao (val) {
      if (val) {
        this.dialogSolicitacao = true
      }
    }
  },
  computed: {
    senhaPin () {
      return this.$store.getters.senhaPin
    },
    senhaClientePlaca () {
      return this.$store.getters.senhaClientePlaca
    },
    success () {
      return this.$store.getters.success
    },
    hasSuccess () {
      return !!this.$store.getters.success
    },
    hasSuccessPlaca () {
      return !!this.$store.getters.success
    },
    error () {
      return this.$store.getters.error
    },
    hasError () {
      return !!this.$store.getters.error
    },
    cliente () {
      return this.$store.getters.cliente
    },
    clienteplaca () {
      return this.$store.getters.veiculo
    },
    completed () {
      return this.codigo && this.codigo.length === 4
    },
    completedPlaca () {
      return this.placa && this.placa.length === 7
    },
    loading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user
    },
    isUserVerified () {
      return this.user ? this.user.emailVerified : null
    },
    frentista () {
      return this.$store.getters.frentista
    },
    compras () {
      return this.$store.getters.compras
    },
    vouchersPremio () {
      return this.$store.getters.vouchersPremio
    },
    vouchersFuncionario () {
      return this.$store.getters.vouchersFuncionario
    },
    authenticate () {
      return !!this.voucherSelected && !this.senhaPin
    },
    authenticateplaca () {
      return !!this.voucherSelectedplaca && !this.senhaClientePlaca
    },
    combustiveis () {
      return this.$store.getters.combustiveis
    },
    hasPin () {
      return !!this.frentista && !this.frentista.data_atualizacao_pin
    },
    notificacao () {
      let dia = new Date().getDate()
      return !!this.frentista && this.frentista.email && (dia > 4 && dia < 11)
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    creditos () {
      return this.$store.getters.creditos
    }
  },
  methods: {
    carregarVouchersplaca () {
      this.$store.dispatch('lookupVouchersPlaca', {
        veiculo: this.placa
      })
    },
    carregarVouchers () {
      this.$store.dispatch('lookupVouchers', this.cpf)
    },
    fecharDialogError () {
      this.$store.dispatch('setError', null)
    },
    fecharDialogSuccess () {
      this.$store.dispatch('setSuccess', null)
    },
    pegarCor (compra) {
      if (compra.combustivel) {
        return compra.combustivel.color
      } else if (compra.pedido && compra.pedido.itens && compra.pedido.itens.length > 0) {
        const item = compra.pedido.itens[0].item
        if (item.combustivel) {
          return item.combustivel.color
        } else {
          return item.categoria.cor
        }
      }
      return 'info'
    },
    pegarTexto (compra) {
      if (compra.combustivel) {
        return compra.combustivel.nome
      } else if (compra.pedido && compra.pedido.itens && compra.pedido.itens.length > 0) {
        const item = compra.pedido.itens[0].item
        if (item.combustivel) {
          return item.combustivel.nome
        } else {
          return item.categoria.nome
        }
      }
      return 'Não informado'
    },
    pegarIcone (compra) {
      if (compra.combustivel) {
        return compra.combustivel.icone
      } else if (compra.pedido && compra.pedido.itens && compra.pedido.itens.length > 0) {
        const item = compra.pedido.itens[0].item
        if (item.combustivel) {
          return item.combustivel.icone
        } else {
          return item.categoria.icone
        }
      }
      return 'Não informado'
    },
    selectVoucherplaca (voucher, compra) {
      if (voucher) {
        this.voucher = voucher
        this.compra = voucher.compra
        this.placaCliente = voucher.compra.cliente
      } else {
        this.voucher = null
        this.compra = compra
        this.placaCliente = compra.cliente
      }
      this.tipo = 'placa'
      this.dialogDetathes = true
    },
    retornoNumeroVoucher (voucherFuncionario) {
      if (voucherFuncionario.voucher) return voucherFuncionario.voucher.numero
      else return voucherFuncionario.compra.codigo || voucherFuncionario.compra.numero
    },
    retornoCombustivelVoucher (voucherFuncionario) {
      if (voucherFuncionario.voucher) {
        return voucherFuncionario.voucher.compra.combustivel
      } else {
        return voucherFuncionario.compra.combustivel
      }
    },
    retornoDataCriacao (voucherFuncionario) {
      if (voucherFuncionario.voucher) {
        return voucherFuncionario.voucher.data_gerado
      } else {
        return voucherFuncionario.compra.data_compra
      }
    },
    retornoValorVoucher (voucherFuncionario) {
      if (voucherFuncionario.voucher) {
        return voucherFuncionario.voucher.valor
      } else {
        return voucherFuncionario.compra.valor_total
      }
    },
    retornoDisponibilidadeVoucher (voucherFuncionario) {
      if (voucherFuncionario.voucher) {
        return voucherFuncionario.voucher.disponivel
      } else {
        return voucherFuncionario.compra.disponivel
      }
    },
    resendEmail () {
      this.$store.dispatch('sendVerifyEmail').then(() => {
        this.snackbar_text = 'Link de verificação enviado, verifique seu e-mail'
        this.snackbar = true
      })
    },
    fazerLogin () {
      this.login.email = this.login.email.trim()
      this.login.password = this.login.password.trim()
      if (this.$refs.form.validate()) {
        this.$store.dispatch('signUserIn', { email: this.login.email, password: this.login.password })
      }
    },
    logout () {
      this.primeiroAcesso = false
      this.$store.dispatch('signUserOut')
    },
    limparCampos () {
      this.clienteSelecionado = null
      this.placaCliente = null
    },
    confirmarMatricula () {
      this.$store.dispatch('confirmarMatricula', {
        'email': this.email,
        'matricula': this.matricula
      }).then(() => {
        this.inserirSenha = true
      })
    },
    cadastrarEmFirebase () {
      this.$store.dispatch('signUserUp', {
        'email': this.email,
        'password': this.senha
      }).then(() => {
        this.clear()
      }).catch(() => {
        this.clear()
        this.primeiroAcesso = false
      })
    },
    clear () {
      this.email = ''
      this.senha = ''
      this.Confirmarsenha = ''
      this.matricula = ''
      this.inserirSenha = false
    },
    opcoes () {
      if (this.inserirSenha) {
        this.cadastrarEmFirebase()
      } else {
        this.confirmarMatricula()
      }
    },
    pegarInformacoes () {
      this.$store.dispatch('pegarCompra', {
        codigo: this.codigo
      }).then(json => {
        this.compra = json
        this.voucher = json.voucher
        this.dialogDetathes = true
      })
    },
    realizarLeitura () {
      this.$store.dispatch('pegarCompra', {
        cnpj: this.frentista.posto.cnpj,
        codigo: this.codigo ? this.codigo : null,
        id_frentista: this.frentistaSelecionado.id_frentista,
        placa: ''
      }).then(() => {
        this.compra = undefined
        this.voucher = undefined
        this.frentistaSelecionado = null
      })
    }
  }
}
</script>

<style>
 .centered-input input {
    text-align: center;
    color: #074d6e !important;
  }
  .pix {
    margin-top: 165px;
  }
  .btn-pix {
    border-radius: 100%;
    width:150px;
    height:150px;
    margin-bottom: 5;
    right: 0;
    bottom: 0;
  }
</style>
